import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { JobPhasePaidBatchResultInterface } from '../interfaces/job-phase-paid-batch-result.interface';

@Exclude()
export class JobPhasePaidBatchResultDto
  implements JobPhasePaidBatchResultInterface
{
  @ApiProperty({
    type: 'number',
    title: 'Marked count',
    description: 'Job phases that received a new "Paid" history entry.',
  })
  @Expose()
  markedCount!: number;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Marked Job Phase IDs',
  })
  @Expose()
  markedJobPhaseIds!: string[];

  @ApiProperty({
    type: 'number',
    title: 'Skipped count',
    description: 'Job phases that were already paid and were left untouched.',
  })
  @Expose()
  skippedCount!: number;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Skipped Job Phase IDs',
  })
  @Expose()
  skippedJobPhaseIds!: string[];
}
